import { message, Space } from "antd"
import { useState } from "react"
import { Button } from "src/global/ui/Button/Button"

interface useEntityChangedMessageProps {
  // onRefresh is called when the user clicks the refresh button
  onRefresh: () => void
  messageContent: string
}

interface useEntityChangedMessageReturn {
  // show is a function that shows the message
  show: () => void
  // container specifies where the message is rendered
  container: React.ReactNode
}

// useMessage wrapper
export function useRealTimeUpdateMessage({
  onRefresh,
  messageContent,
}: useEntityChangedMessageProps): useEntityChangedMessageReturn {
  const [shown, setShown] = useState(false)
  const [msg, container] = message.useMessage()

  const onClick = () => {
    onRefresh()
    msg.destroy()
    setShown(false)
  }

  const show = () => {
    if (shown) {
      // prevent multiple redundant messages from being shown
      return
    }

    msg.info(
      <Space size="large">
        <>{messageContent}</>
        <Button type="text" size="small" icon="redo" onClick={onClick}>
          Refresh
        </Button>
      </Space>,
      0,
    )

    setShown(true)
  }

  return {
    show,
    container,
  }
}
